module.exports = __webpack_public_path__ + "fonts/saphir_fff22aa5da105499e91581ef6a138815.ttf";